import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import "core-js/modules/es.array.for-each.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
import "core-js/modules/es.object.define-properties.js";
import "core-js/modules/es.object.define-property.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.replace.js";
import "core-js/modules/es.string.starts-with.js";
import "core-js/modules/es.string.match.js";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.string.trim.js";
import "core-js/modules/es.date.to-string.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.regexp.to-string.js";
import "core-js/modules/es.array.find.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.string.split.js";
import _objectWithoutProperties from "/home/vsts/work/1/s/dp-components/node_modules/next/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties";
import _initializerDefineProperty from "/home/vsts/work/1/s/dp-components/node_modules/next/node_modules/@babel/runtime/helpers/esm/initializerDefineProperty";
import _classCallCheck from "/home/vsts/work/1/s/dp-components/node_modules/next/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/home/vsts/work/1/s/dp-components/node_modules/next/node_modules/@babel/runtime/helpers/esm/createClass";
import _defineProperty from "/home/vsts/work/1/s/dp-components/node_modules/next/node_modules/@babel/runtime/helpers/esm/defineProperty";
import _applyDecoratedDescriptor from "/home/vsts/work/1/s/dp-components/node_modules/next/node_modules/@babel/runtime/helpers/esm/applyDecoratedDescriptor";

var _class, _descriptor, _descriptor2, _descriptor3, _descriptor4, _descriptor5;

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}
/* eslint sonarjs/no-duplicate-string: 0 */


import { DATE_CONSIDERATIONS, decodeOrderType, formatPhoneNumber, isLogicalAnd, ORDER_TYPES, zipDeterminer } from "@dp/common";
import { action, computed, makeObservable, observable, runInAction } from "mobx";
import moment from "moment-timezone";
import { ORDER_TYPE } from ".";
import BrandRules from "../../utils/BrandRules";
import i18next from "i18next";
import { formatPriceOC, getMinMaxQuotes } from "../../utils/common";
var OrderConfirmationModel = (_class = /*#__PURE__*/function () {
  function OrderConfirmationModel(platformUtil) {
    _classCallCheck(this, OrderConfirmationModel);

    _initializerDefineProperty(this, "_lastOrderData", _descriptor, this);

    _initializerDefineProperty(this, "_cartItems", _descriptor2, this);

    _initializerDefineProperty(this, "_appAttributes", _descriptor3, this);

    _initializerDefineProperty(this, "_sessionDetails", _descriptor4, this);

    _initializerDefineProperty(this, "_restaurantDetail", _descriptor5, this);

    makeObservable(this);
  }

  _createClass(OrderConfirmationModel, [{
    key: "setSessionDetails",
    value: function setSessionDetails(sessionDetails) {
      this._sessionDetails = sessionDetails;
    }
  }, {
    key: "setAppAttributes",
    value: function setAppAttributes(appAttributes) {
      this._appAttributes = appAttributes;
    }
  }, {
    key: "setLastOrderData",
    value: function setLastOrderData(lastOrderData) {
      this._lastOrderData = lastOrderData;
    }
  }, {
    key: "setRestaurantDetailData",
    value: function setRestaurantDetailData(restaurantDetail) {
      this._restaurantDetail = restaurantDetail;
    }
  }, {
    key: "setCartItems",
    value: function setCartItems(cartItems) {
      this._cartItems = cartItems;
    }
  }, {
    key: "parseMarketingSectionString",
    value: function parseMarketingSectionString(str) {
      try {
        var _str$replace;

        var data = str === null || str === void 0 ? void 0 : (_str$replace = str.replace(/([a-zA-Z0-9]+?):(?![\/\/])/gm, '"$1":')) === null || _str$replace === void 0 ? void 0 : _str$replace.replace(/'/g, '"');
        return JSON.parse(data);
      } catch (_unused) {
        return [];
      }
    }
  }, {
    key: "decodeSpecialInstructions",
    value: function decodeSpecialInstructions() {
      var _this$_lastOrderData, _this$_lastOrderData$, _this$_lastOrderData2, _this$_lastOrderData3, _this$_lastOrderData6, _this$_lastOrderData7, _this$_lastOrderData10, _this$_lastOrderData11, _this$_lastOrderData12;

      var items = [];
      var specialInstruction = (_this$_lastOrderData = this._lastOrderData) === null || _this$_lastOrderData === void 0 ? void 0 : (_this$_lastOrderData$ = _this$_lastOrderData.order) === null || _this$_lastOrderData$ === void 0 ? void 0 : _this$_lastOrderData$.specialInstruction; //  if special instructions are present only then construct the string for items and silverware

      if (specialInstruction) {
        var _specialInstruction$s;

        var instructionText = specialInstruction.instructionText,
            noOfGuests = specialInstruction.noOfGuests,
            silverwareOption = specialInstruction.silverwareOption,
            Silverware = specialInstruction.Silverware,
            _specialInstruction$c = specialInstruction.contactPerson,
            contactPerson = _specialInstruction$c === void 0 ? '' : _specialInstruction$c,
            _specialInstruction$c2 = specialInstruction.contactPhone,
            contactPhone = _specialInstruction$c2 === void 0 ? '' : _specialInstruction$c2,
            orderItems = _objectWithoutProperties(specialInstruction, ["instructionText", "noOfGuests", "silverwareOption", "Silverware", "contactPerson", "contactPhone"]);

        var complimentryItems = "";

        if ((specialInstruction === null || specialInstruction === void 0 ? void 0 : (_specialInstruction$s = specialInstruction.silverwareOption) === null || _specialInstruction$s === void 0 ? void 0 : _specialInstruction$s.toLowerCase()) === "yes") {
          complimentryItems += "Include Silverware (Forks, Knives, Spoons and Napkins), ";
        }

        for (var key in orderItems) {
          var item = orderItems[key];

          if (item !== null && item !== void 0 && item.startsWith("No") || item !== null && item !== void 0 && item.startsWith("no")) {
            continue;
          }

          if (item !== null && item !== void 0 && item.match(/\d/)) {
            var formattedString = item === null || item === void 0 ? void 0 : item.replace(/\d/g, "");
            if (formattedString !== null && formattedString !== void 0 && formattedString.length) complimentryItems += "".concat(formattedString, ", ");
          } else {
            if (item) complimentryItems += "".concat(item, ", ");
          }
        }

        if (complimentryItems.length > 0) {
          items.push({
            title: i18next.t("text.orderconf.thank.complimentry"),
            // replace last comma with a period
            subTitle: complimentryItems.replace(/,\s*$/, ".")
          });
        }

        if (instructionText) {
          items.push({
            title: i18next.t("text.orderconf.thank.spl.inst"),
            subTitle: instructionText
          });
        }
      }

      if ((_this$_lastOrderData2 = this._lastOrderData) !== null && _this$_lastOrderData2 !== void 0 && (_this$_lastOrderData3 = _this$_lastOrderData2.order) !== null && _this$_lastOrderData3 !== void 0 && _this$_lastOrderData3.deliveryOccasion) {
        var _this$_lastOrderData4, _this$_lastOrderData5;

        items.push({
          title: i18next.t("text.orderconf.thank.occasion"),
          subTitle: (_this$_lastOrderData4 = this._lastOrderData) === null || _this$_lastOrderData4 === void 0 ? void 0 : (_this$_lastOrderData5 = _this$_lastOrderData4.order) === null || _this$_lastOrderData5 === void 0 ? void 0 : _this$_lastOrderData5.deliveryOccasion
        });
      }

      if ((_this$_lastOrderData6 = this._lastOrderData) !== null && _this$_lastOrderData6 !== void 0 && (_this$_lastOrderData7 = _this$_lastOrderData6.order) !== null && _this$_lastOrderData7 !== void 0 && _this$_lastOrderData7.driverInstructions) {
        var _this$_lastOrderData8, _this$_lastOrderData9;

        items.push({
          title: i18next.t("text.orderconf.thank.driver.inst"),
          subTitle: (_this$_lastOrderData8 = this._lastOrderData) === null || _this$_lastOrderData8 === void 0 ? void 0 : (_this$_lastOrderData9 = _this$_lastOrderData8.order) === null || _this$_lastOrderData9 === void 0 ? void 0 : _this$_lastOrderData9.driverInstructions
        });
      }

      if ((_this$_lastOrderData10 = this._lastOrderData) !== null && _this$_lastOrderData10 !== void 0 && (_this$_lastOrderData11 = _this$_lastOrderData10.order) !== null && _this$_lastOrderData11 !== void 0 && (_this$_lastOrderData12 = _this$_lastOrderData11.shippingGroup) !== null && _this$_lastOrderData12 !== void 0 && _this$_lastOrderData12.deliveryDropOffOption) {
        var _this$_lastOrderData13, _this$_lastOrderData14, _this$_lastOrderData15;

        var deliveryDropOffOption = (_this$_lastOrderData13 = this._lastOrderData) === null || _this$_lastOrderData13 === void 0 ? void 0 : (_this$_lastOrderData14 = _this$_lastOrderData13.order) === null || _this$_lastOrderData14 === void 0 ? void 0 : (_this$_lastOrderData15 = _this$_lastOrderData14.shippingGroup) === null || _this$_lastOrderData15 === void 0 ? void 0 : _this$_lastOrderData15.deliveryDropOffOption;

        if (deliveryDropOffOption === "MEET_AT_MY_DOOR") {
          items.push({
            title: "Delivery Option",
            subTitle: "Meet at my door"
          });
        } else if (deliveryDropOffOption === "LEAVE_AT_DOOR") {
          items.push({
            title: "Delivery Option",
            subTitle: "Leave at door"
          });
        }
      }

      return {
        items: items
      };
    }
  }, {
    key: "showFormattedPrice",
    value: function showFormattedPrice(num) {
      var _BrandRules, _this$_appAttributes;

      return formatPriceOC(Number(num), (_BrandRules = new BrandRules((_this$_appAttributes = this._appAttributes) === null || _this$_appAttributes === void 0 ? void 0 : _this$_appAttributes.currentConceptCode)) === null || _BrandRules === void 0 ? void 0 : _BrandRules.pricingFormat());
    }
  }, {
    key: "getFormatedDateInOC",
    value: function getFormatedDateInOC(time) {
      var includeTime = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;

      var getSuperScript = function getSuperScript(sup) {
        var res = sup.replace(/(\d)(st)/i, "$1ˢᵗ").replace(/(\d)(nd)/i, "$1ⁿᵈ").replace(/(\d)(rd)/i, "$1ʳᵈ").replace(/(\d)(th)/i, "$1ᵗʰ");
        return res;
      };

      var today = moment();
      var tomorrow = moment().add(1, "days");
      var date = moment(time);
      if (date.isSame(today, "d")) return getSuperScript(date.format(this.hideSuperScript() ? "[Today], MMM D" + (includeTime ? ", h:mm A" : "") : "[Today], MMM Do" + (includeTime ? ", h:mm A" : "")));else if (date.isSame(tomorrow, "d")) return getSuperScript(date.format(this.hideSuperScript() ? "[Tomorrow], MMM D" + (includeTime ? ", h:mm A" : "") : "[Tomorrow], MMM Do" + (includeTime ? ", h:mm A" : "")));else {
        if (includeTime) {
          return getSuperScript(this.hideSuperScript() ? date.format("MMM D, h:mm A") : date.format("MMM Do, h:mm A"));
        } else {
          return getSuperScript(date.format("MM/DD/YYYY"));
        }
      }
    }
  }, {
    key: "getFormatedDateInOCForMobile",
    value: function getFormatedDateInOCForMobile(time) {
      var includeTime = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
      var today = moment();
      var tomorrow = moment().add(1, "days");
      var date = moment(time);
      if (date.isSame(today, "d")) return date.format("[Today], MMM D" + (includeTime ? ", h:mm A" : ""));else if (date.isSame(tomorrow, "d")) return date.format("[Tomorrow], MMM D" + (includeTime ? ", h:mm A" : ""));else {
        if (includeTime) {
          return this.hideSuperScript() ? date.format("MMM D, h:mm A") : date.format("MMM Do, h:mm A");
        } else {
          return date.format("MM/DD/YYYY");
        }
      }
    }
  }, {
    key: "hideSuperScript",
    value: function hideSuperScript() {
      var _this$_appAttributes2, _this$_appAttributes3;

      return ((_this$_appAttributes2 = this._appAttributes) === null || _this$_appAttributes2 === void 0 ? void 0 : (_this$_appAttributes3 = _this$_appAttributes2.currentConceptCode) === null || _this$_appAttributes3 === void 0 ? void 0 : _this$_appAttributes3.toLowerCase()) === "cs";
    }
  }, {
    key: "getShareTextDetails",
    value: function getShareTextDetails() {
      return {
        orderNumber: this.orderInfo.orderNumber,
        name: this.orderInfo.name,
        orderTotal: this.showFormattedPrice(this.priceInfo.orderTotal),
        orderType: decodeOrderType(this.orderInfo.orderType),
        pickupDetails: this.pickupDetails,
        restaurantDetails: this.addressDetails,
        restaurantPhone: this.orderInfo.orderType === ORDER_TYPES.CATERING_DELIVERY ? this.deliveryAddress.phoneNumber : this.addressDetails.restPhone
      };
    }
  }, {
    key: "resetModel",
    value: function resetModel() {
      var _this = this;

      runInAction(function () {
        _this._appAttributes = null;
        _this._cartItems = [];
        _this._lastOrderData = null;
        _this._restaurantDetail = null;
        _this._sessionDetails = null;
      });
    }
  }, {
    key: "lastOrderData",
    get: function get() {
      var _this$_lastOrderData16;

      return (_this$_lastOrderData16 = this._lastOrderData) === null || _this$_lastOrderData16 === void 0 ? void 0 : _this$_lastOrderData16.order;
    }
  }, {
    key: "completeLastOrder",
    get: function get() {
      return this._lastOrderData;
    }
  }, {
    key: "cartItems",
    get: function get() {
      return this._cartItems;
    }
  }, {
    key: "pickupDetails",
    get: function get() {
      var _this$_lastOrderData17, _this$_lastOrderData18, _shippingGroup$pickup, _shippingGroup$firstN, _shippingGroup$phoneN, _shippingGroup$pickup2, _shippingGroup$firstN2, _shippingGroup$lastNa;

      var shippingGroup = (_this$_lastOrderData17 = this._lastOrderData) === null || _this$_lastOrderData17 === void 0 ? void 0 : (_this$_lastOrderData18 = _this$_lastOrderData17.order) === null || _this$_lastOrderData18 === void 0 ? void 0 : _this$_lastOrderData18.shippingGroup;
      return {
        carType: shippingGroup === null || shippingGroup === void 0 ? void 0 : shippingGroup.carType,
        carColor: shippingGroup === null || shippingGroup === void 0 ? void 0 : shippingGroup.carColor,
        pickupByName: (shippingGroup === null || shippingGroup === void 0 ? void 0 : (_shippingGroup$pickup = shippingGroup.pickupBy) === null || _shippingGroup$pickup === void 0 ? void 0 : _shippingGroup$pickup.trim()) || (shippingGroup === null || shippingGroup === void 0 ? void 0 : (_shippingGroup$firstN = shippingGroup.firstName) === null || _shippingGroup$firstN === void 0 ? void 0 : _shippingGroup$firstN.trim()),
        pickupByPhone: formatPhoneNumber(shippingGroup === null || shippingGroup === void 0 ? void 0 : (_shippingGroup$phoneN = shippingGroup.phoneNumber) === null || _shippingGroup$phoneN === void 0 ? void 0 : _shippingGroup$phoneN.toString()),
        pickupMethod: shippingGroup === null || shippingGroup === void 0 ? void 0 : shippingGroup.pickupMethod,
        firstName: (shippingGroup === null || shippingGroup === void 0 ? void 0 : (_shippingGroup$pickup2 = shippingGroup.pickupBy) === null || _shippingGroup$pickup2 === void 0 ? void 0 : _shippingGroup$pickup2.trim()) || (shippingGroup === null || shippingGroup === void 0 ? void 0 : (_shippingGroup$firstN2 = shippingGroup.firstName) === null || _shippingGroup$firstN2 === void 0 ? void 0 : _shippingGroup$firstN2.trim()),
        lastName: shippingGroup === null || shippingGroup === void 0 ? void 0 : (_shippingGroup$lastNa = shippingGroup.lastName) === null || _shippingGroup$lastNa === void 0 ? void 0 : _shippingGroup$lastNa.trim()
      };
    }
  }, {
    key: "itemsTotalQuantity",
    get: function get() {
      var _this$_lastOrderData19, _this$_lastOrderData20;

      var items = 0;
      var commerceItems = (_this$_lastOrderData19 = this._lastOrderData) === null || _this$_lastOrderData19 === void 0 ? void 0 : (_this$_lastOrderData20 = _this$_lastOrderData19.order) === null || _this$_lastOrderData20 === void 0 ? void 0 : _this$_lastOrderData20.commerceItems;

      if (commerceItems) {
        commerceItems.forEach(function (item) {
          items += item.quantity;
        });
      }

      return items;
    }
  }, {
    key: "orderInfo",
    get: function get() {
      var _this$_lastOrderData21, _shippingGroup$firstN4, _order$priceInfo;

      var order = (_this$_lastOrderData21 = this._lastOrderData) === null || _this$_lastOrderData21 === void 0 ? void 0 : _this$_lastOrderData21.order;

      var _this$decodeSpecialIn = this.decodeSpecialInstructions(),
          items = _this$decodeSpecialIn.items;

      if ((order === null || order === void 0 ? void 0 : order.orderType) === ORDER_TYPE.CATERING_DELIVERY) {
        var _shippingGroup$firstN3;

        var _shippingGroup = order.shippingGroup;
        return {
          name: _shippingGroup === null || _shippingGroup === void 0 ? void 0 : (_shippingGroup$firstN3 = _shippingGroup.firstName) === null || _shippingGroup$firstN3 === void 0 ? void 0 : _shippingGroup$firstN3.trim(),
          email: _shippingGroup === null || _shippingGroup === void 0 ? void 0 : _shippingGroup.emailId,
          orderId: order.orderId,
          orderNumber: order === null || order === void 0 ? void 0 : order.orderNumber,
          orderType: order.orderType,
          noOfItems: order === null || order === void 0 ? void 0 : order.commerceItems.length,
          orderAmount: order.priceInfo.amount,
          payInRestaurant: order.payInRestaurant,
          items: items
        };
      }

      var shippingGroup = order === null || order === void 0 ? void 0 : order.shippingGroup;
      return {
        name: shippingGroup === null || shippingGroup === void 0 ? void 0 : (_shippingGroup$firstN4 = shippingGroup.firstName) === null || _shippingGroup$firstN4 === void 0 ? void 0 : _shippingGroup$firstN4.trim(),
        email: shippingGroup === null || shippingGroup === void 0 ? void 0 : shippingGroup.emailId,
        orderId: order === null || order === void 0 ? void 0 : order.orderId,
        orderType: order === null || order === void 0 ? void 0 : order.orderType,
        orderNumber: order === null || order === void 0 ? void 0 : order.orderNumber,
        payInRestaurant: order === null || order === void 0 ? void 0 : order.payInRestaurant,
        noOfItems: order === null || order === void 0 ? void 0 : order.commerceItems.length,
        orderAmount: order === null || order === void 0 ? void 0 : (_order$priceInfo = order.priceInfo) === null || _order$priceInfo === void 0 ? void 0 : _order$priceInfo.amount,
        items: items
      };
    }
  }, {
    key: "priceInfo",
    get: function get() {
      var _this$_lastOrderData22, _order$priceInfo2, _order$priceInfo3, _order$priceInfo4, _order$priceInfo5, _order$priceInfo6, _order$priceInfo7, _order$priceInfo8, _order$priceInfo9, _order$priceInfo10;

      var order = (_this$_lastOrderData22 = this._lastOrderData) === null || _this$_lastOrderData22 === void 0 ? void 0 : _this$_lastOrderData22.order;
      return {
        tax: order === null || order === void 0 ? void 0 : (_order$priceInfo2 = order.priceInfo) === null || _order$priceInfo2 === void 0 ? void 0 : _order$priceInfo2.tax,
        gratuity: order === null || order === void 0 ? void 0 : order.totalTipAmount,
        subtotal: order === null || order === void 0 ? void 0 : (_order$priceInfo3 = order.priceInfo) === null || _order$priceInfo3 === void 0 ? void 0 : _order$priceInfo3.rawSubTotal,
        orderTotal: (order === null || order === void 0 ? void 0 : (_order$priceInfo4 = order.priceInfo) === null || _order$priceInfo4 === void 0 ? void 0 : _order$priceInfo4.total) + (order === null || order === void 0 ? void 0 : order.totalTipAmount),
        couponDiscount: order === null || order === void 0 ? void 0 : (_order$priceInfo5 = order.priceInfo) === null || _order$priceInfo5 === void 0 ? void 0 : _order$priceInfo5.discountAmount,
        deliveryFee: (order === null || order === void 0 ? void 0 : order.orderType) === ORDER_TYPES.TOGO_DELIVERY ? order === null || order === void 0 ? void 0 : (_order$priceInfo6 = order.priceInfo) === null || _order$priceInfo6 === void 0 ? void 0 : _order$priceInfo6.fixedFee : order === null || order === void 0 ? void 0 : order.deliveryFee,
        serviceFee: order === null || order === void 0 ? void 0 : (_order$priceInfo7 = order.priceInfo) === null || _order$priceInfo7 === void 0 ? void 0 : _order$priceInfo7.variableFee,
        taxesAndFees: (order === null || order === void 0 ? void 0 : (_order$priceInfo8 = order.priceInfo) === null || _order$priceInfo8 === void 0 ? void 0 : _order$priceInfo8.tax) + (order === null || order === void 0 ? void 0 : (_order$priceInfo9 = order.priceInfo) === null || _order$priceInfo9 === void 0 ? void 0 : _order$priceInfo9.variableFee),
        bagFee: order === null || order === void 0 ? void 0 : (_order$priceInfo10 = order.priceInfo) === null || _order$priceInfo10 === void 0 ? void 0 : _order$priceInfo10.bagFee
      };
    }
  }, {
    key: "togoDeliveryDetails",
    get: function get() {
      var _this$_lastOrderData23, _this$_lastOrderData24, _this$_lastOrderData25, _this$_lastOrderData26, _this$_lastOrderData27, _this$_lastOrderData28, _restaurantAddress$ph, _restaurantAddress$ph2;

      var shippingAddress = (_this$_lastOrderData23 = this._lastOrderData) === null || _this$_lastOrderData23 === void 0 ? void 0 : (_this$_lastOrderData24 = _this$_lastOrderData23.order) === null || _this$_lastOrderData24 === void 0 ? void 0 : _this$_lastOrderData24.shippingGroup;
      var restaurantAddress = (_this$_lastOrderData25 = this._lastOrderData) === null || _this$_lastOrderData25 === void 0 ? void 0 : (_this$_lastOrderData26 = _this$_lastOrderData25.order) === null || _this$_lastOrderData26 === void 0 ? void 0 : _this$_lastOrderData26.restaurantAddres;
      return {
        shippingAddress: shippingAddress,
        restaurantAddress: _objectSpread(_objectSpread({}, restaurantAddress), {}, {
          restaurantName: (_this$_lastOrderData27 = this._lastOrderData) === null || _this$_lastOrderData27 === void 0 ? void 0 : (_this$_lastOrderData28 = _this$_lastOrderData27.order) === null || _this$_lastOrderData28 === void 0 ? void 0 : _this$_lastOrderData28.restaurantName,
          phoneNumber: formatPhoneNumber(restaurantAddress === null || restaurantAddress === void 0 ? void 0 : (_restaurantAddress$ph = restaurantAddress.phoneDetail) === null || _restaurantAddress$ph === void 0 ? void 0 : (_restaurantAddress$ph2 = _restaurantAddress$ph.find(function (p) {
            return p.type === "Primary";
          })) === null || _restaurantAddress$ph2 === void 0 ? void 0 : _restaurantAddress$ph2.phoneNumber)
        })
      };
    }
  }, {
    key: "deliveryAddress",
    get: function get() {
      var _this$_lastOrderData29, _this$_lastOrderData30, _this$_lastOrderData31, _this$_lastOrderData32, _this$_lastOrderData33, _this$_lastOrderData34, _this$_lastOrderData35, _this$_lastOrderData36, _this$_lastOrderData37, _this$_lastOrderData38, _this$_lastOrderData39, _this$_restaurantDeta, _this$_restaurantDeta2, _this$_restaurantDeta3, _this$_restaurantDeta4, _this$_restaurantDeta5, _this$_restaurantDeta6, _this$_restaurantDeta7, _this$_restaurantDeta8, _this$_restaurantDeta9;

      var address = (_this$_lastOrderData29 = this._lastOrderData) === null || _this$_lastOrderData29 === void 0 ? void 0 : (_this$_lastOrderData30 = _this$_lastOrderData29.order) === null || _this$_lastOrderData30 === void 0 ? void 0 : _this$_lastOrderData30.shippingGroup;
      var deliveryDate = (_this$_lastOrderData31 = this._lastOrderData) === null || _this$_lastOrderData31 === void 0 ? void 0 : (_this$_lastOrderData32 = _this$_lastOrderData31.order) === null || _this$_lastOrderData32 === void 0 ? void 0 : _this$_lastOrderData32.deliveryDate;
      var deliveryTime = (_this$_lastOrderData33 = this._lastOrderData) === null || _this$_lastOrderData33 === void 0 ? void 0 : (_this$_lastOrderData34 = _this$_lastOrderData33.order) === null || _this$_lastOrderData34 === void 0 ? void 0 : _this$_lastOrderData34.deliveryTime;
      var deliveryDateAndTime = isLogicalAnd(deliveryDate, deliveryTime) ? moment("".concat(deliveryDate, " ").concat(deliveryTime), DATE_CONSIDERATIONS.DATE_TIME_FORMAT_WITH_SLASH).valueOf() : null;
      return {
        deliveryRestaurantName: (_this$_lastOrderData35 = this._lastOrderData) === null || _this$_lastOrderData35 === void 0 ? void 0 : (_this$_lastOrderData36 = _this$_lastOrderData35.order) === null || _this$_lastOrderData36 === void 0 ? void 0 : _this$_lastOrderData36.restaurantName,
        shippingAddress: "".concat(address !== null && address !== void 0 && address.address2 ? address === null || address === void 0 ? void 0 : address.address2 : ""),
        shippingAddressLineTwo: "".concat(address === null || address === void 0 ? void 0 : address.city, ", ").concat(address === null || address === void 0 ? void 0 : address.stateName, ", ").concat(address === null || address === void 0 ? void 0 : address.postalCode).trim(),
        shippingAddressName: address === null || address === void 0 ? void 0 : address.address1,
        noOfGuests: (_this$_lastOrderData37 = this._lastOrderData) === null || _this$_lastOrderData37 === void 0 ? void 0 : (_this$_lastOrderData38 = _this$_lastOrderData37.order) === null || _this$_lastOrderData38 === void 0 ? void 0 : (_this$_lastOrderData39 = _this$_lastOrderData38.specialInstruction) === null || _this$_lastOrderData39 === void 0 ? void 0 : _this$_lastOrderData39.noOfGuests,
        phoneNumber: formatPhoneNumber(address === null || address === void 0 ? void 0 : address.phoneNumber),
        deliveryTime: this.getFormatedDateInOC(deliveryDateAndTime),
        deliveryRestaurantId: (_this$_restaurantDeta = this._restaurantDetail) === null || _this$_restaurantDeta === void 0 ? void 0 : _this$_restaurantDeta.atgRestaurantId,
        longitude: (_this$_restaurantDeta2 = this._restaurantDetail) === null || _this$_restaurantDeta2 === void 0 ? void 0 : (_this$_restaurantDeta3 = _this$_restaurantDeta2.contactDetail) === null || _this$_restaurantDeta3 === void 0 ? void 0 : (_this$_restaurantDeta4 = _this$_restaurantDeta3.address) === null || _this$_restaurantDeta4 === void 0 ? void 0 : (_this$_restaurantDeta5 = _this$_restaurantDeta4.coordinates) === null || _this$_restaurantDeta5 === void 0 ? void 0 : _this$_restaurantDeta5.longitude,
        latitude: (_this$_restaurantDeta6 = this._restaurantDetail) === null || _this$_restaurantDeta6 === void 0 ? void 0 : (_this$_restaurantDeta7 = _this$_restaurantDeta6.contactDetail) === null || _this$_restaurantDeta7 === void 0 ? void 0 : (_this$_restaurantDeta8 = _this$_restaurantDeta7.address) === null || _this$_restaurantDeta8 === void 0 ? void 0 : (_this$_restaurantDeta9 = _this$_restaurantDeta8.coordinates) === null || _this$_restaurantDeta9 === void 0 ? void 0 : _this$_restaurantDeta9.latitude
      };
    }
  }, {
    key: "addressDetails",
    get: function get() {
      var _this$_lastOrderData40, _this$_lastOrderData41, _this$_lastOrderData42, _this$_lastOrderData43, _this$_lastOrderData44, _this$_lastOrderData45, _this$_lastOrderData46, _this$_lastOrderData47, _this$_lastOrderData48, _this$_lastOrderData49, _this$_lastOrderData50, _this$_restaurantDeta10, _this$_lastOrderData51, _this$_lastOrderData52, _this$_lastOrderData53, _restAddress$coordina, _restAddress$coordina2, _this$_restaurantDeta11;

      var phone = (_this$_lastOrderData40 = this._lastOrderData) === null || _this$_lastOrderData40 === void 0 ? void 0 : (_this$_lastOrderData41 = _this$_lastOrderData40.order) === null || _this$_lastOrderData41 === void 0 ? void 0 : (_this$_lastOrderData42 = _this$_lastOrderData41.restaurantAddres) === null || _this$_lastOrderData42 === void 0 ? void 0 : (_this$_lastOrderData43 = _this$_lastOrderData42.phoneDetail) === null || _this$_lastOrderData43 === void 0 ? void 0 : _this$_lastOrderData43.find(function (p) {
        return p.type === "Primary";
      });
      var restAddress = (_this$_lastOrderData44 = this._lastOrderData) === null || _this$_lastOrderData44 === void 0 ? void 0 : (_this$_lastOrderData45 = _this$_lastOrderData44.order) === null || _this$_lastOrderData45 === void 0 ? void 0 : (_this$_lastOrderData46 = _this$_lastOrderData45.restaurantAddres) === null || _this$_lastOrderData46 === void 0 ? void 0 : _this$_lastOrderData46.address;
      var pickupDate = (_this$_lastOrderData47 = this._lastOrderData) === null || _this$_lastOrderData47 === void 0 ? void 0 : (_this$_lastOrderData48 = _this$_lastOrderData47.order) === null || _this$_lastOrderData48 === void 0 ? void 0 : _this$_lastOrderData48.pickupDate;
      var pickupTime = (_this$_lastOrderData49 = this._lastOrderData) === null || _this$_lastOrderData49 === void 0 ? void 0 : (_this$_lastOrderData50 = _this$_lastOrderData49.order) === null || _this$_lastOrderData50 === void 0 ? void 0 : _this$_lastOrderData50.pickupTime;
      var pickupDateAndTime = isLogicalAnd(pickupDate, pickupTime) ? moment("".concat(pickupDate, " ").concat(pickupTime), DATE_CONSIDERATIONS.DATE_TIME_FORMAT_WITH_SLASH).valueOf() : null;
      return {
        restName: (_this$_restaurantDeta10 = this._restaurantDetail) === null || _this$_restaurantDeta10 === void 0 ? void 0 : _this$_restaurantDeta10.restaurantName,
        restAddress: "".concat(restAddress === null || restAddress === void 0 ? void 0 : restAddress.street1).concat(restAddress !== null && restAddress !== void 0 && restAddress.street2 ? ", " + (restAddress === null || restAddress === void 0 ? void 0 : restAddress.street2) : "").trim(),
        addressLineTwo: " ".concat(restAddress === null || restAddress === void 0 ? void 0 : restAddress.city).concat(restAddress !== null && restAddress !== void 0 && restAddress.stateCode ? ", " + (restAddress === null || restAddress === void 0 ? void 0 : restAddress.stateCode) : "", " ").concat(restAddress !== null && restAddress !== void 0 && restAddress.zipCode ? zipDeterminer({
          zipCode: restAddress === null || restAddress === void 0 ? void 0 : restAddress.zipCode,
          country: restAddress === null || restAddress === void 0 ? void 0 : restAddress.country
        }) : "").trim(),
        restPhone: formatPhoneNumber(phone === null || phone === void 0 ? void 0 : phone.phoneNumber),
        pickupTime: pickupDateAndTime && this.getFormatedDateInOC(pickupDateAndTime),
        noOfGuests: (_this$_lastOrderData51 = this._lastOrderData) === null || _this$_lastOrderData51 === void 0 ? void 0 : (_this$_lastOrderData52 = _this$_lastOrderData51.order) === null || _this$_lastOrderData52 === void 0 ? void 0 : (_this$_lastOrderData53 = _this$_lastOrderData52.specialInstruction) === null || _this$_lastOrderData53 === void 0 ? void 0 : _this$_lastOrderData53.noOfGuests,
        longitude: restAddress === null || restAddress === void 0 ? void 0 : (_restAddress$coordina = restAddress.coordinates) === null || _restAddress$coordina === void 0 ? void 0 : _restAddress$coordina.longitude,
        latitude: restAddress === null || restAddress === void 0 ? void 0 : (_restAddress$coordina2 = restAddress.coordinates) === null || _restAddress$coordina2 === void 0 ? void 0 : _restAddress$coordina2.latitude,
        restId: (_this$_restaurantDeta11 = this._restaurantDetail) === null || _this$_restaurantDeta11 === void 0 ? void 0 : _this$_restaurantDeta11.atgRestaurantId,
        pickupTimeForMobile: pickupDateAndTime && this.getFormatedDateInOCForMobile(pickupDateAndTime)
      };
    }
  }, {
    key: "getPaymentDetails",
    get: function get() {
      var _this$_lastOrderData54, _this$_lastOrderData55, _this$_lastOrderData56;

      var details = [];
      (_this$_lastOrderData54 = this._lastOrderData) === null || _this$_lastOrderData54 === void 0 ? void 0 : (_this$_lastOrderData55 = _this$_lastOrderData54.order) === null || _this$_lastOrderData55 === void 0 ? void 0 : (_this$_lastOrderData56 = _this$_lastOrderData55.paymentGroup) === null || _this$_lastOrderData56 === void 0 ? void 0 : _this$_lastOrderData56.forEach(function (amount) {
        var _ref;

        details.push({
          creditCardType: amount === null || amount === void 0 ? void 0 : amount.creditCardType,
          amount: (_ref = (amount === null || amount === void 0 ? void 0 : amount.amount) + (amount === null || amount === void 0 ? void 0 : amount.tipAmount) + (amount === null || amount === void 0 ? void 0 : amount.paygrpTipAmount)) !== null && _ref !== void 0 ? _ref : 0,
          paygrpTipAmount: amount === null || amount === void 0 ? void 0 : amount.paygrpTipAmount,
          tipAmount: amount === null || amount === void 0 ? void 0 : amount.tipAmount,
          paymentMethod: amount === null || amount === void 0 ? void 0 : amount.paymentMethod,
          paymentCardToken: amount === null || amount === void 0 ? void 0 : amount.paymentCardToken,
          giftCardNumber: amount === null || amount === void 0 ? void 0 : amount.giftCardNumber,
          giftCardType: amount === null || amount === void 0 ? void 0 : amount.giftCardType,
          walletType: amount === null || amount === void 0 ? void 0 : amount.walletType
        });
      });
      return details;
    }
  }, {
    key: "pickupMyOrderDetails",
    get: function get() {
      var _this2 = this;

      try {
        var _this$_appAttributes4, _this$_appAttributes5, _data$replace, _parsedData$curbsideD;

        var data = (_this$_appAttributes4 = this._appAttributes) === null || _this$_appAttributes4 === void 0 ? void 0 : (_this$_appAttributes5 = _this$_appAttributes4.configs) === null || _this$_appAttributes5 === void 0 ? void 0 : _this$_appAttributes5["pickupMyOrderDetails"];
        var parsedData = JSON.parse(data === null || data === void 0 ? void 0 : (_data$replace = data.replace(/([a-zA-Z0-9]+?):(?![\/\/])/gm, '"$1":')) === null || _data$replace === void 0 ? void 0 : _data$replace.replace(/'/g, '"'));
        var inRest = !!(parsedData !== null && parsedData !== void 0 && parsedData.inRest) ? parsedData === null || parsedData === void 0 ? void 0 : parsedData.inRest.map(function (item) {
          var _this2$_appAttributes;

          return {
            text: item.text,
            imageURL: ((_this2$_appAttributes = _this2._appAttributes) === null || _this2$_appAttributes === void 0 ? void 0 : _this2$_appAttributes.configs[item.imageURL]) || null
          };
        }).filter(function (item) {
          return i18next.exists(item.text);
        }) : [];
        var curbsideEnabled = parsedData === null || parsedData === void 0 ? void 0 : parsedData.curbsideEnabled.map(function (item) {
          var _this2$_appAttributes2;

          return {
            text: item.text,
            imageURL: ((_this2$_appAttributes2 = _this2._appAttributes) === null || _this2$_appAttributes2 === void 0 ? void 0 : _this2$_appAttributes2.configs[item.imageURL]) || null,
            heading: item.heading || null
          };
        }).filter(function (item) {
          return i18next.exists(item.text);
        });
        var curbsideDisabled = parsedData === null || parsedData === void 0 ? void 0 : (_parsedData$curbsideD = parsedData.curbsideDisabled) === null || _parsedData$curbsideD === void 0 ? void 0 : _parsedData$curbsideD.map(function (item) {
          var _this2$_appAttributes3;

          return {
            text: item.text,
            imageURL: ((_this2$_appAttributes3 = _this2._appAttributes) === null || _this2$_appAttributes3 === void 0 ? void 0 : _this2$_appAttributes3.configs[item.imageURL]) || null
          };
        }).filter(function (item) {
          return i18next.exists(item.text);
        });
        return {
          inRest: inRest,
          curbsideEnabled: curbsideEnabled,
          curbsideDisabled: curbsideDisabled
        };
      } catch (_unused2) {
        return {};
      }
    }
  }, {
    key: "thanksForYourOrderImageURL",
    get: function get() {
      var _this$_appAttributes6, _this$_appAttributes7, _this$_appAttributes8, _this$_appAttributes9, _this$_appAttributes10, _this$_appAttributes11;

      try {
        var _this$_lastOrderData57;

        var order = (_this$_lastOrderData57 = this._lastOrderData) === null || _this$_lastOrderData57 === void 0 ? void 0 : _this$_lastOrderData57.order;

        switch (order === null || order === void 0 ? void 0 : order.orderType) {
          case ORDER_TYPE.CATERING_DELIVERY:
            return ((_this$_appAttributes6 = this._appAttributes) === null || _this$_appAttributes6 === void 0 ? void 0 : (_this$_appAttributes7 = _this$_appAttributes6.configs) === null || _this$_appAttributes7 === void 0 ? void 0 : _this$_appAttributes7["confirmation_thanksfororder_catering_delivery"]) || "";

          case ORDER_TYPE.TOGO_PICKUP:
            return ((_this$_appAttributes8 = this._appAttributes) === null || _this$_appAttributes8 === void 0 ? void 0 : (_this$_appAttributes9 = _this$_appAttributes8.configs) === null || _this$_appAttributes9 === void 0 ? void 0 : _this$_appAttributes9["confirmation_thanksfororder_togo_pickup"]) || "";

          case ORDER_TYPE.CATERING_PICKUP:
            return ((_this$_appAttributes10 = this._appAttributes) === null || _this$_appAttributes10 === void 0 ? void 0 : (_this$_appAttributes11 = _this$_appAttributes10.configs) === null || _this$_appAttributes11 === void 0 ? void 0 : _this$_appAttributes11["confirmation_thanksfororder_catering_pickup"]) || "";

          default:
            return "";
        }
      } catch (_unused3) {
        return "";
      }
    }
  }, {
    key: "showTakeSurvey",
    get: function get() {
      var _this$_appAttributes12, _this$_appAttributes13;

      return ((_this$_appAttributes12 = this._appAttributes) === null || _this$_appAttributes12 === void 0 ? void 0 : (_this$_appAttributes13 = _this$_appAttributes12.configs) === null || _this$_appAttributes13 === void 0 ? void 0 : _this$_appAttributes13.enableSurveyField) === "true";
    }
  }, {
    key: "deliverySurveyMbUrl",
    get: function get() {
      var _this$_appAttributes14, _this$_appAttributes15;

      return (_this$_appAttributes14 = this._appAttributes) === null || _this$_appAttributes14 === void 0 ? void 0 : (_this$_appAttributes15 = _this$_appAttributes14.configs) === null || _this$_appAttributes15 === void 0 ? void 0 : _this$_appAttributes15.deliverySurveyMbUrl;
    }
  }, {
    key: "deliverySurveyDeskUrl",
    get: function get() {
      var _this$_appAttributes16, _this$_appAttributes17;

      return (_this$_appAttributes16 = this._appAttributes) === null || _this$_appAttributes16 === void 0 ? void 0 : (_this$_appAttributes17 = _this$_appAttributes16.configs) === null || _this$_appAttributes17 === void 0 ? void 0 : _this$_appAttributes17.deliverySurveyDeskUrl;
    }
  }, {
    key: "cateringSurveyMbUrl",
    get: function get() {
      var _this$_appAttributes18, _this$_appAttributes19;

      return (_this$_appAttributes18 = this._appAttributes) === null || _this$_appAttributes18 === void 0 ? void 0 : (_this$_appAttributes19 = _this$_appAttributes18.configs) === null || _this$_appAttributes19 === void 0 ? void 0 : _this$_appAttributes19.cateringSurveyMbUrl;
    }
  }, {
    key: "cateringSurveyDeskUrl",
    get: function get() {
      var _this$_appAttributes20, _this$_appAttributes21;

      return (_this$_appAttributes20 = this._appAttributes) === null || _this$_appAttributes20 === void 0 ? void 0 : (_this$_appAttributes21 = _this$_appAttributes20.configs) === null || _this$_appAttributes21 === void 0 ? void 0 : _this$_appAttributes21.cateringSurveyDeskUrl;
    }
  }, {
    key: "togoSurveyMbUrl",
    get: function get() {
      var _this$_appAttributes22, _this$_appAttributes23;

      return (_this$_appAttributes22 = this._appAttributes) === null || _this$_appAttributes22 === void 0 ? void 0 : (_this$_appAttributes23 = _this$_appAttributes22.configs) === null || _this$_appAttributes23 === void 0 ? void 0 : _this$_appAttributes23.togoSurveyMbUrl;
    }
  }, {
    key: "togoSurveyDeskUrl",
    get: function get() {
      var _this$_appAttributes24, _this$_appAttributes25;

      return (_this$_appAttributes24 = this._appAttributes) === null || _this$_appAttributes24 === void 0 ? void 0 : (_this$_appAttributes25 = _this$_appAttributes24.configs) === null || _this$_appAttributes25 === void 0 ? void 0 : _this$_appAttributes25.togoSurveyDeskUrl;
    }
  }, {
    key: "togoSurveyAppUrl",
    get: function get() {
      var _this$_appAttributes26, _this$_appAttributes27;

      return (_this$_appAttributes26 = this._appAttributes) === null || _this$_appAttributes26 === void 0 ? void 0 : (_this$_appAttributes27 = _this$_appAttributes26.configs) === null || _this$_appAttributes27 === void 0 ? void 0 : _this$_appAttributes27.togoSurveyAppUrl;
    }
  }, {
    key: "showEclubField",
    get: function get() {
      var _this$_appAttributes28, _this$_appAttributes29;

      return ((_this$_appAttributes28 = this._appAttributes) === null || _this$_appAttributes28 === void 0 ? void 0 : (_this$_appAttributes29 = _this$_appAttributes28.configs) === null || _this$_appAttributes29 === void 0 ? void 0 : _this$_appAttributes29.enableEclubField) === "true";
    }
  }, {
    key: "hideRestOfTheBrands",
    get: function get() {
      var _this$_appAttributes30, _this$_appAttributes31;

      return ((_this$_appAttributes30 = this._appAttributes) === null || _this$_appAttributes30 === void 0 ? void 0 : (_this$_appAttributes31 = _this$_appAttributes30.configs) === null || _this$_appAttributes31 === void 0 ? void 0 : _this$_appAttributes31.hideRestOfTheBrands) === "true";
    }
  }, {
    key: "eclubExternalURL",
    get: function get() {
      var _this$_appAttributes32, _this$_appAttributes33;

      return (_this$_appAttributes32 = this._appAttributes) === null || _this$_appAttributes32 === void 0 ? void 0 : (_this$_appAttributes33 = _this$_appAttributes32.configs) === null || _this$_appAttributes33 === void 0 ? void 0 : _this$_appAttributes33.subscribeExternalUrl;
    }
  }, {
    key: "isCurbsideNotificationEnabled",
    get: function get() {
      var _this$_restaurantDeta12, _this$_restaurantDeta13;

      return (_this$_restaurantDeta12 = this._restaurantDetail) === null || _this$_restaurantDeta12 === void 0 ? void 0 : (_this$_restaurantDeta13 = _this$_restaurantDeta12.features) === null || _this$_restaurantDeta13 === void 0 ? void 0 : _this$_restaurantDeta13.curbSideTogoEnabled;
    }
  }, {
    key: "isOrderTrackingEnabled",
    get: function get() {
      var _this$_restaurantDeta14, _this$_restaurantDeta15, _this$_lastOrderData58, _this$_lastOrderData59, _this$_lastOrderData60;

      var orderTrackingEnable = (_this$_restaurantDeta14 = this._restaurantDetail) === null || _this$_restaurantDeta14 === void 0 ? void 0 : (_this$_restaurantDeta15 = _this$_restaurantDeta14.features) === null || _this$_restaurantDeta15 === void 0 ? void 0 : _this$_restaurantDeta15.orderTrackingEnabled;
      var isOrderTypeCateringDelivery = ((_this$_lastOrderData58 = this._lastOrderData) === null || _this$_lastOrderData58 === void 0 ? void 0 : _this$_lastOrderData58.order.orderType) === ORDER_TYPES.CATERING_DELIVERY;
      var isTogoDelivery = ((_this$_lastOrderData59 = this._lastOrderData) === null || _this$_lastOrderData59 === void 0 ? void 0 : (_this$_lastOrderData60 = _this$_lastOrderData59.order) === null || _this$_lastOrderData60 === void 0 ? void 0 : _this$_lastOrderData60.orderType) === ORDER_TYPES.TOGO_DELIVERY;
      return orderTrackingEnable && !isOrderTypeCateringDelivery && !isTogoDelivery;
    }
  }, {
    key: "marketingSectionData",
    get: function get() {
      var _this$_lastOrderData61, _this$_lastOrderData62, _this$_appAttributes34, _this$_appAttributes35, _this$_appAttributes36, _this$_appAttributes37;

      var marketingSectionData = ((_this$_lastOrderData61 = this._lastOrderData) === null || _this$_lastOrderData61 === void 0 ? void 0 : (_this$_lastOrderData62 = _this$_lastOrderData61.order) === null || _this$_lastOrderData62 === void 0 ? void 0 : _this$_lastOrderData62.orderType) === ORDER_TYPE.TOGO_DELIVERY ? (_this$_appAttributes34 = this._appAttributes) === null || _this$_appAttributes34 === void 0 ? void 0 : (_this$_appAttributes35 = _this$_appAttributes34.configs) === null || _this$_appAttributes35 === void 0 ? void 0 : _this$_appAttributes35["orderconf_ext_delivery_marketing_data"] : (_this$_appAttributes36 = this._appAttributes) === null || _this$_appAttributes36 === void 0 ? void 0 : (_this$_appAttributes37 = _this$_appAttributes36.configs) === null || _this$_appAttributes37 === void 0 ? void 0 : _this$_appAttributes37["orderconf_marketing_data"];

      if (!!marketingSectionData) {
        try {
          return this.parseMarketingSectionString(marketingSectionData);
        } catch (_unused4) {
          return [];
        }
      }

      return [];
    }
  }, {
    key: "signUpSource",
    get: function get() {
      var _this$_appAttributes38, _this$_appAttributes39, _this$_appAttributes40, _this$_appAttributes41;

      var desktop = (_this$_appAttributes38 = this._appAttributes) === null || _this$_appAttributes38 === void 0 ? void 0 : (_this$_appAttributes39 = _this$_appAttributes38.configs) === null || _this$_appAttributes39 === void 0 ? void 0 : _this$_appAttributes39["orderconf-signupsrc"];
      var mobile = (_this$_appAttributes40 = this._appAttributes) === null || _this$_appAttributes40 === void 0 ? void 0 : (_this$_appAttributes41 = _this$_appAttributes40.configs) === null || _this$_appAttributes41 === void 0 ? void 0 : _this$_appAttributes41["orderconf-m-signupsrc"];
      return {
        desktop: desktop,
        mobile: mobile
      };
    }
  }, {
    key: "deliveryRestPhoneNumber",
    get: function get() {
      var _this$_restaurantDeta16, _this$_restaurantDeta17, _this$_restaurantDeta18;

      var phone = (_this$_restaurantDeta16 = this._restaurantDetail) === null || _this$_restaurantDeta16 === void 0 ? void 0 : (_this$_restaurantDeta17 = _this$_restaurantDeta16.contactDetail) === null || _this$_restaurantDeta17 === void 0 ? void 0 : (_this$_restaurantDeta18 = _this$_restaurantDeta17.phoneDetail) === null || _this$_restaurantDeta18 === void 0 ? void 0 : _this$_restaurantDeta18.find(function (p) {
        return p.type === "Primary";
      });
      return formatPhoneNumber(phone === null || phone === void 0 ? void 0 : phone.phoneNumber);
    }
  }, {
    key: "secondarySignupSources",
    get: function get() {
      var _this$_appAttributes42, _this$_appAttributes43;

      var sourcesString = (_this$_appAttributes42 = this._appAttributes) === null || _this$_appAttributes42 === void 0 ? void 0 : (_this$_appAttributes43 = _this$_appAttributes42.configs) === null || _this$_appAttributes43 === void 0 ? void 0 : _this$_appAttributes43["orderconf-secondary-signup"];
      var sources = sourcesString === null || sourcesString === void 0 ? void 0 : sourcesString.split(",");

      if (sources) {
        return sources === null || sources === void 0 ? void 0 : sources.map(function (source) {
          var _source, _brandNameRegex$exec;

          source = (_source = source) === null || _source === void 0 ? void 0 : _source.replace(/["']/g, "");
          var brandNameRegex = /general-(.*)-[lL]ogo/;
          var brandName = (_brandNameRegex$exec = brandNameRegex.exec(source)) === null || _brandNameRegex$exec === void 0 ? void 0 : _brandNameRegex$exec[1];
          return {
            clubName: source,
            imageName: "".concat(brandName, "-club")
          };
        });
      }

      return [];
    }
  }, {
    key: "isCurbsideTogo",
    get: function get() {
      var _this$_restaurantDeta19, _this$_restaurantDeta20;

      return (_this$_restaurantDeta19 = this._restaurantDetail) === null || _this$_restaurantDeta19 === void 0 ? void 0 : (_this$_restaurantDeta20 = _this$_restaurantDeta19.features) === null || _this$_restaurantDeta20 === void 0 ? void 0 : _this$_restaurantDeta20.curbSideTogoEnabled;
    }
  }, {
    key: "posCheckReference",
    get: function get() {
      var _this$_lastOrderData63, _this$_lastOrderData64;

      return (_this$_lastOrderData63 = this._lastOrderData) === null || _this$_lastOrderData63 === void 0 ? void 0 : (_this$_lastOrderData64 = _this$_lastOrderData63.order) === null || _this$_lastOrderData64 === void 0 ? void 0 : _this$_lastOrderData64.checkReferencePOS;
    }
  }, {
    key: "timeEstimate",
    get: function get() {
      var _this$_lastOrderData65, _this$_lastOrderData66, _this$_lastOrderData67;

      var quote = (_this$_lastOrderData65 = this._lastOrderData) === null || _this$_lastOrderData65 === void 0 ? void 0 : (_this$_lastOrderData66 = _this$_lastOrderData65.order) === null || _this$_lastOrderData66 === void 0 ? void 0 : (_this$_lastOrderData67 = _this$_lastOrderData66.shippingGroup) === null || _this$_lastOrderData67 === void 0 ? void 0 : _this$_lastOrderData67.quote;

      if (!quote) {
        return null;
      }

      var minMaxQuotes = getMinMaxQuotes(quote);
      return "".concat(minMaxQuotes.minTime, "-").concat(minMaxQuotes.maxTime, " Minutes");
    }
  }]);

  return OrderConfirmationModel;
}(), (_descriptor = _applyDecoratedDescriptor(_class.prototype, "_lastOrderData", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return null;
  }
}), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "_cartItems", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return [];
  }
}), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, "_appAttributes", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return null;
  }
}), _descriptor4 = _applyDecoratedDescriptor(_class.prototype, "_sessionDetails", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return null;
  }
}), _descriptor5 = _applyDecoratedDescriptor(_class.prototype, "_restaurantDetail", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return null;
  }
}), _applyDecoratedDescriptor(_class.prototype, "setSessionDetails", [action], Object.getOwnPropertyDescriptor(_class.prototype, "setSessionDetails"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "setAppAttributes", [action], Object.getOwnPropertyDescriptor(_class.prototype, "setAppAttributes"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "lastOrderData", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "lastOrderData"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "completeLastOrder", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "completeLastOrder"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "setLastOrderData", [action], Object.getOwnPropertyDescriptor(_class.prototype, "setLastOrderData"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "setRestaurantDetailData", [action], Object.getOwnPropertyDescriptor(_class.prototype, "setRestaurantDetailData"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "setCartItems", [action], Object.getOwnPropertyDescriptor(_class.prototype, "setCartItems"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "cartItems", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "cartItems"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "pickupDetails", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "pickupDetails"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "itemsTotalQuantity", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "itemsTotalQuantity"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "orderInfo", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "orderInfo"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "priceInfo", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "priceInfo"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "togoDeliveryDetails", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "togoDeliveryDetails"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "deliveryAddress", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "deliveryAddress"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "addressDetails", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "addressDetails"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "getPaymentDetails", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "getPaymentDetails"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "pickupMyOrderDetails", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "pickupMyOrderDetails"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "thanksForYourOrderImageURL", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "thanksForYourOrderImageURL"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "showTakeSurvey", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "showTakeSurvey"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "deliverySurveyMbUrl", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "deliverySurveyMbUrl"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "deliverySurveyDeskUrl", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "deliverySurveyDeskUrl"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "cateringSurveyMbUrl", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "cateringSurveyMbUrl"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "cateringSurveyDeskUrl", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "cateringSurveyDeskUrl"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "togoSurveyMbUrl", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "togoSurveyMbUrl"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "togoSurveyDeskUrl", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "togoSurveyDeskUrl"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "togoSurveyAppUrl", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "togoSurveyAppUrl"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "showEclubField", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "showEclubField"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "hideRestOfTheBrands", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "hideRestOfTheBrands"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "eclubExternalURL", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "eclubExternalURL"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "isCurbsideNotificationEnabled", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "isCurbsideNotificationEnabled"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "isOrderTrackingEnabled", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "isOrderTrackingEnabled"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "marketingSectionData", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "marketingSectionData"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "signUpSource", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "signUpSource"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "deliveryRestPhoneNumber", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "deliveryRestPhoneNumber"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "secondarySignupSources", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "secondarySignupSources"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "isCurbsideTogo", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "isCurbsideTogo"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "posCheckReference", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "posCheckReference"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "timeEstimate", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "timeEstimate"), _class.prototype)), _class);
export { OrderConfirmationModel as default };